import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/one/components/main/NextUIProvider.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/one/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/one/styles/global.css");
;
import(/* webpackMode: "eager" */ "/var/www/one/styles/application.css");
;
import(/* webpackMode: "eager" */ "/var/www/one/styles/telega-chat.scss");
